const DashboardConfig = {
    DRAWER_WIDTH: parseInt(process.env.REACT_APP_DRAWER_WIDTH!)
}

export default DashboardConfig;